import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.jobCooperate.query,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.jobCooperate.save,
    method: 'post',
    data: requestBody
  })
}

// 批量新增/修改保存
export function batchSave(requestBody) {
  return request({
    url: URL.jobCooperate.batchSave,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.jobCooperate.remove,
    method: 'post',
    data: requestBody
  })
}

// 更新协作/业务/费用状态
export function updateState(requestBody) {
  return request({
    url: URL.jobCooperate.updateState,
    method: 'post',
    data: requestBody
  })
}

// 协作/业务/费用状态变更日志
export function getCooperateStatusLog(requestBody) {
  return request({
    url: URL.jobCooperate.getCooperateStatusLog,
    method: 'post',
    data: requestBody
  })
}

// 查询分润记录
export function queryProfitShare(requestBody) {
  return request({
    url: URL.jobCooperate.queryProfitShareUrl,
    method: 'post',
    data: requestBody
  })
}

// 生成分润记录
export function generateProfitShare(requestBody) {
  return request({
    url: URL.jobCooperate.generateProfitShareUrl,
    method: 'post',
    data: requestBody
  })
}
